import { API } from "../../../../config";
import CONSTANTS from "../../../../constants/constants";
import AxiosUtils from "../../../../utils/AxiosUtils";
import Cookies from "../../../../utils/Cookies";
import { mockAPIPath, serverAPIPath } from "../config";

class VerifyInvitationService {
    private payload: object;
    private isHitDummyURL: boolean;
    private headers: object;

    constructor(payload = {}, isHitDummyURL = false) {
        this.payload = payload;
        this.isHitDummyURL = isHitDummyURL;
        this.headers = { "access-token": new Cookies("access-token").read() };
    }

    async verifyInviteLink(code:any){
        const response = await new AxiosUtils(`${API.BASE_URL}${serverAPIPath.VERIFY_INVITE_LINK}${code}`, this.payload, this.headers).put();
        let isInviteLinkVerified: string;
        if(response?.data?.success==true) {
            isInviteLinkVerified = response?.data?.message;
            const redirectUrl= response.data?.data?.redirectUrl;
            return {
                isInviteLinkVerified,
                redirectUrl
            };
        } else if (response?.success == false) {
            throw new Error(response?.message);
        } else {
            throw new Error(response);
        }
    }

    async verifyInviteLinkDemo(code: any) {
        const response = await new AxiosUtils(
            `${API.BASE_URL}${serverAPIPath.VERIFY_INVITE_LINK_DEMO}/${code}`,
            this.payload,
            { "demo-user": CONSTANTS.DEMO_USER_CONSTANTS }
        ).post();
        let isInviteLinkVerified: string;
        if (response?.data?.success == true) {
            isInviteLinkVerified = response?.data?.message;
            const redirectUrl= response.data?.data?.redirectUrl;
            return {
                isInviteLinkVerified,
                redirectUrl
            };
        } else if (response?.data?.success === false) {
            throw new Error(response?.data?.message);
        }else{
            throw new Error(response);
        } 
    }

}

export default VerifyInvitationService;